<template>
  <div class="g-wp">
    <div class="commentBox" id="header">
      <div class="comment">
        <img :src="userAvatar" alt="">
        <textarea name="评论" v-model="comment"></textarea>
      </div>
      <button @click="postCommen">发布评论</button>
    </div>
    <div class="commentList">
      <ul class="reply-list">
        <li v-for="( item, index ) in commentList " :key="index">
          <div class="portrait">
            <img :src="item.user.userAvatar" alt="">
          </div>
          <div class="content">
            <div class="title">
              <p class="p-class-name" @click="toDetail( item.commentId )">{{ item.user.userName }}</p>
              <div v-if="commentType === 'course'" class="ico" @click="giveLike( item, index )">
                <span :class="[item.isLike ? 'ico_2' : 'ico_1']">{{ item.likeCount }}</span>
              </div>
            </div>
            <p class="p-content">{{ item.text }}</p>
            <div class="p-reply">
              <span>{{ item.createTime | formatDate }}</span>
              <span v-if="commentType === 'course'" class="s-right" @click="toDetail( item.commentId )">回复TA</span>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="commentList.length < total" class="load-more f-dn" style="display: block;" @click="getCommentList">{{ loadText }}</div>
    </div>
  </div>
</template>
<script>
/* global getCachedUser */
/* global gotoLogin */
/* global YitongToken */
/* global $http */

export default {
  name: 'comment',
  data() {
    return {
      userAvatar: 'https://public.yitong.com/images/yitong-avatar.png',
      comment: '',
      commentLength: 0,
      commentLong: 300,
      commentList: [],
      newTime: Date.parse(new Date()),
      loadText: '加载更多',
      total: 0,
      /**
       * 查询评论列表类型
       *
       * course
       * // 通过课程查询
       *
       * reply
       * // 通过评论id查询评论
       */
      commentType: ''
    }
  },
  mounted() {},
  methods: {
    /**
     * 初始化
     */
    init(options) {
      if (options.commentId && options.courseId) {
        // 查询 回复评论
        this.courseId = options.courseId
        this.commentId = options.commentId
        this.commentType = 'reply'
      } else if (options.courseId) {
        // 查询 课程评论
        this.courseId = options.courseId
        this.commentType = 'course'
      }
      this.getCommentList(null)

      getCachedUser()
        .then(user => {
          this.userAvatar =
            user.avatar || 'https://public.yitong.com/images/yitong-avatar.png'
        })
        .catch(() => {
          this.userAvatar = 'https://public.yitong.com/images/yitong-avatar.png'
        })
    },

    /**
     * 跳转评论详情
     */
    toDetail(id) {
      if (this.commentType === 'course') {
        const routeUrl = this.$router.resolve({
          path: '/commentDetail',
          query: {
            commentId: id,
            courseId: this.courseId
          }
        })
        window.open(routeUrl.href, '_blank')
      }
    },

    /**
     * 点赞
     */
    giveLike(row, index) {
      if (!YitongToken.get()) {
        gotoLogin()
        return
      }

      $http
        .post('/yswx/gw/comment/setCommentLike', {
          // 必传，评论的id
          commentId: row.commentId,
          // 点赞传1，取消点赞传0，必传
          like: row.isLike ? 0 : 1
        })
        .then(() => {
          if (row.isLike) {
            --row.likeCount
          } else {
            ++row.likeCount
          }

          this.commentList[index].isLike = !row.isLike
          this.commentList[index].likeCount = row.likeCount
        })
    },

    /**
     * 发布评论
     */
    postCommen() {
      if (!YitongToken.get()) {
        gotoLogin()
        return
      }

      if (this.comment.length === 0) {
        this.$alert('请输入您的评论内容', '评论内容不能为空！', {
          confirmButtonText: '确定'
        })
        return
      }

      // 请求参数
      let params = {}
      // 请求地址
      let url = ''
      if (this.commentType === 'course') {
        params = {
          // 评论主体对象课程id，必传
          // courseId: user.id,
          courseId: this.courseId,
          // 课程的类型，必传：vip课程传VIP     课程集锦传VIDEO   一对多培训传TRAINING
          type: 'VIDEO',
          // 发表的评论内容
          commentText: this.comment
        }
        url = '/yswx/gw/comment/addCourseCommentByType'
      } else if (this.commentType === 'reply') {
        params = {
          // 评论主体课程id，必传
          courseId: this.courseId,
          // 评论id，必传
          commentId: this.commentId,
          // 发表的评论内容
          replyText: this.comment
        }
        url = '/yswx/gw/comment/addReply'
      }

      $http.post(url, params).then(() => {
        this.comment = ''
        this._next = null
        this.getCommentList('submit')
      })
    },

    /**
     * 获取评论列表
     *
     * @param {String} getType - 渲染评论列表类型
     * @returns
     */
    getCommentList(getType) {
      this.loadText = '加载中...'

      // 请求参数
      let params = {}
      // 请求地址
      let url = ''
      if (this.commentType === 'course') {
        params = {
          courseId: this.courseId,
          next: this._next || '',
          page: 1,
          pageSize: 20
        }
        url = '/yswx/gw/comment/getCourseCommentListForPC'
      } else if (this.commentType === 'reply') {
        params = {
          commentId: this.commentId,
          next: this._next || '',
          page: 1,
          pageSize: 20
        }
        url = '/yswx/gw/comment/getReplyList'
      }

      return $http
        .post(url, params)
        .then(data => {
          if (getType === 'submit') {
            this.commentList = data.result.list
          } else {
            this.commentList = this.commentList.concat(data.result.list)
          }
          this._next = data.result.next
          this.total = data.result.total

          if (this.commentType === 'course') {
            this.$parent.setReplyCount(this.total)
          }
          return data
        })
        .catch(err => Promise.reject(err))
        .finally(() => {
          this.loadText = '加载更多'
        })
    }
  },
  watch: {
    comment: function() {
      this.commentLength = this.comment.length
      if (this.commentLength > this.commentLong) {
        this.comment = this.comment.substring(0, this.commentLong)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.ico_1 {
  background: url(../assets/img/comment_01.png) no-repeat;
  background-position: 0 10px;
  width: 49px;
  background-size: 39%;
}
.ico_2 {
  background: url(../assets/img/comment_02.png) no-repeat;
  background-position: 0 10px;
  width: 49px;
  background-size: 39%;
  color: #ff5d5d;
}
.ico_3 {
  background: url(../assets/img/comment_03.png) no-repeat;
  background-position: 0 10px;
  width: 49px;
  background-size: 39%;
  margin-left: 21px;
}
.g-wp {
  width: 880px;
}
.commentBox {
  .character {
    text-align: right;
  }
  .comment {
    width: 100%;
    height: 100px;
    display: flex;
    img {
      width: 96px;
      height: 96px;
      border-radius: 50%;
      margin-right: 37px;
    }
    textarea {
      flex: 1;
      width: 950px;
      height: 60px;
      background: rgba(240, 240, 240, 1);
      padding: 20px;
      border: 1px solid #c7c7c7;
    }
  }
  button {
    width: 182px;
    border: 0;
    height: 40px;
    margin-top: 25px;
    background: #cf2c25;
    color: #fff;
    float: right;
    border-radius: 4px;
  }
}
.commentList {
  margin: 90px 0;
  .s-right {
    float: right;
    font-size: 12px;
    span {
      margin-left: 10px;
      color: #999;
    }
  }
}
.load-more {
  color: #b5b5b5;
  margin: 5px 0 30px;
  background-color: #f1f1f1;
  line-height: 50px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
}
</style>